import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { HelpIcon } from './helpIcon';
import { CopyToClipboardButton } from '../buttons/copyToClipboardButton';
export function CopyableCode(t0) {
  const $ = _c(45);
  const {
    title,
    code,
    codeClassName,
    variant,
    tooltipTitle,
    maxHeight,
    blur: t1
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const color = variant === "error" ? "var(--mui-palette-error-main)" : "var(--mui-palette-text-primary)";
  const bgColorClass = variant === "error" ? "bg-(--mui-palette-error-opacity)" : "bg-(--mui-palette-background-secondary)";
  if (title) {
    const t2 = `w-full p-[16px] ${bgColorClass} rounded-[4px]`;
    let t3;
    if ($[0] !== maxHeight) {
      t3 = {
        maxHeight
      };
      $[0] = maxHeight;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== color) {
      t4 = <Divider sx={{
        borderStyle: "dashed",
        borderColor: color
      }} />;
      $[2] = color;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== color || $[5] !== title) {
      t5 = <Typography variant="subtitle1" fontWeight="bold" color={color}>{title}</Typography>;
      $[4] = color;
      $[5] = title;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== tooltipTitle) {
      t6 = tooltipTitle && <HelpIcon alwaysVisible={true} title={tooltipTitle} className="text-xl" tooltipProps={{
        disableInteractive: false
      }} />;
      $[7] = tooltipTitle;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const t7 = blur ? "" : code;
    const t8 = blur ? "Fill all required fields before copy" : undefined;
    const t9 = `text-[${color}]`;
    let t10;
    if ($[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
      t10 = <CopyToClipboardButton textToCopy={t7} disabledTooltip={t8} className={t9} />;
      $[9] = t7;
      $[10] = t8;
      $[11] = t9;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    let t11;
    if ($[13] !== t10 || $[14] !== t6) {
      t11 = <Stack direction="row" gap="8px" alignItems="center">{t6}{t10}</Stack>;
      $[13] = t10;
      $[14] = t6;
      $[15] = t11;
    } else {
      t11 = $[15];
    }
    let t12;
    if ($[16] !== t11 || $[17] !== t5) {
      t12 = <Stack direction="row" gap="8px" alignItems="center" justifyContent="space-between">{t5}{t11}</Stack>;
      $[16] = t11;
      $[17] = t5;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] !== blur || $[20] !== code || $[21] !== codeClassName || $[22] !== color) {
      t13 = <CodeBlock code={code} className={codeClassName} color={color} blur={blur} />;
      $[19] = blur;
      $[20] = code;
      $[21] = codeClassName;
      $[22] = color;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    let t14;
    if ($[24] !== t12 || $[25] !== t13 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
      t14 = <Stack className={t2} sx={t3} divider={t4} gap="12px">{t12}{t13}</Stack>;
      $[24] = t12;
      $[25] = t13;
      $[26] = t2;
      $[27] = t3;
      $[28] = t4;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    return t14;
  }
  const t2 = `w-full p-[16px] ${bgColorClass} rounded-[4px]`;
  let t3;
  if ($[30] !== maxHeight) {
    t3 = {
      maxHeight
    };
    $[30] = maxHeight;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  let t4;
  if ($[32] !== blur || $[33] !== code || $[34] !== codeClassName || $[35] !== color) {
    t4 = <CodeBlock code={code} className={codeClassName} color={color} blur={blur} />;
    $[32] = blur;
    $[33] = code;
    $[34] = codeClassName;
    $[35] = color;
    $[36] = t4;
  } else {
    t4 = $[36];
  }
  const t5 = blur ? "" : code;
  const t6 = `text-[${color}]`;
  let t7;
  if ($[37] !== t5 || $[38] !== t6) {
    t7 = <CopyToClipboardButton textToCopy={t5} className={t6} />;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] !== t2 || $[41] !== t3 || $[42] !== t4 || $[43] !== t7) {
    t8 = <Stack direction="row" gap="8px" alignItems="start" className={t2} sx={t3}>{t4}{t7}</Stack>;
    $[40] = t2;
    $[41] = t3;
    $[42] = t4;
    $[43] = t7;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  return t8;
}
const CodeBlock = t0 => {
  const $ = _c(6);
  const {
    code,
    className,
    color,
    blur: t1
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const t2 = ` break-pretty w-full whitespace-pre overflow-x-auto text-[13px] text-[${color}] ${className ?? ""}`;
  let t3;
  if ($[0] !== blur || $[1] !== code) {
    t3 = blur ? <span className="select-none pointer-events-none" style={{
      userSelect: "none",
      color: "var(--mui-palette-text-disabled)"
    }}>{code}</span> : code;
    $[0] = blur;
    $[1] = code;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <code className={t2}>{t3}</code>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};